// src/components/admin/flows/panels/DelayConfigForm.js
import React from 'react';
import { Clock } from 'lucide-react';
import { useTheme } from '../../../../contexts/ThemeContext';

const DelayConfigForm = ({ config, onChange }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const inputClass = `w-full px-3 py-2 rounded-lg text-sm border ${
        isDark ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
    } focus:ring-2 focus:ring-blue-500 focus:outline-none`;

    const labelClass = `block text-xs font-medium mb-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`;

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3">
                <div>
                    <label className={labelClass}>Duration</label>
                    <input
                        type="number"
                        value={config.duration_hours || 24}
                        onChange={(e) => onChange({ ...config, duration_hours: parseInt(e.target.value) || 1 })}
                        className={inputClass}
                        min={1}
                    />
                </div>
                <div>
                    <label className={labelClass}>Unit</label>
                    <select
                        value={config.duration_type || 'hours'}
                        onChange={(e) => onChange({ ...config, duration_type: e.target.value })}
                        className={inputClass}
                    >
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                        <option value="business_days">Business Days</option>
                    </select>
                </div>
            </div>

            {/* Preview */}
            <div className={`flex items-center gap-2 p-3 rounded-lg ${isDark ? 'bg-gray-700' : 'bg-gray-50'}`}>
                <Clock className={`w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
                <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                    Wait {config.duration_hours || 24} {config.duration_type || 'hours'}
                    {config.duration_type === 'business_days' && ' (excludes weekends & holidays)'}
                </p>
            </div>
        </div>
    );
};

export default DelayConfigForm;
